import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const ASSETS_API = process.env.NEXT_PUBLIC_ASSETS_API;

export const FIREBASE_API = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APPID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

export const PUBLIC_NODE_ENV = process.env.NEXT_PUBLIC_NODE_ENV;

/* eslint-disable */
export const NEXT_PUBLIC_API_CONNECTOR_NEXUS_API_GATE_HOST = process.env.NEXT_PUBLIC_API_CONNECTOR_NEXUS_API_GATE_HOST;
export const NEXT_PUBLIC_KIOSK_DOMAIN = process.env.NEXT_PUBLIC_KIOSK_DOMAIN;
export const NEXT_PUBLIC_CMS_DOMAIN = process.env.NEXT_PUBLIC_CMS_DOMAIN;
/* eslint-enable */

export const WEBSOCKET_CONFIG = {
  // 각 서비스의 웹소켓 접속 전체 URL을 동적으로 생성
  urls: {
    accommodation: `${NEXT_PUBLIC_API_CONNECTOR_NEXUS_API_GATE_HOST}${process.env.NEXT_PUBLIC_WEBSOCKET_ACCOMMODATION_PATH}`,
    reservation: `${NEXT_PUBLIC_API_CONNECTOR_NEXUS_API_GATE_HOST}${process.env.NEXT_PUBLIC_WEBSOCKET_RESERVATION_PATH}`,
  },
  // STOMP 토픽 경로
  topics: {
    roomNumberEvent: process.env.NEXT_PUBLIC_WEBSOCKET_ROOM_NUMBER_EVENT_TOPIC,
    mqttHealthStatus: process.env.NEXT_PUBLIC_WEBSOCKET_MQTT_HEALTH_STATUS_TOPIC,
    reservationEvent: process.env.NEXT_PUBLIC_WEBSOCKET_RESERVATION_EVENTS_TOPIC,
  },
};
